import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MedIconsModule } from "@mk/med-icons";

import { MedExternalLinkComponent } from "./med-external-link.component";

@NgModule({
  declarations: [
    MedExternalLinkComponent,
  ],
  imports: [
    CommonModule,
    MedIconsModule,
  ],
  exports: [
    MedExternalLinkComponent,
  ],
})
export class MedExternalLinkModule { }
